import Checkbox from '@visa/vds/checkbox';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import CheckboxSet from '@visa/vds/checkbox-set';
import Col from '@visa/vds/col';
import DateSelector from '@visa/vds/date-selector';
import Divider from '@visa/vds/divider';
import Row from '@visa/vds/row';
import format from 'date-fns/format';
import enUS from 'date-fns/locale/en-US';
import React from 'react';
import '../../Style/Store.css';

const OtherProductDetails = (props) => {


    return (
        <>
            <Divider type="section" />
            <Row className="store-product-details-row">
                <Col lg={4}>
                    <CheckboxSet>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    name="checkbox-subscription-select"
                                    label="ACS Setup (Pre-Production only)"
                                    value={props.ACS_SETUP}
                                    onChange={props.handleSubscriptionSelected}
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                    </CheckboxSet>
                </Col>
                {props.selectedSubscription != null && props.selectedSubscription.values.includes(props.ACS_SETUP) &&
                    <Col lg={4}>

                        <DateSelector
                            className="subscription-select-startdate"
                            label={`Start Date (example, ${format(new Date(), enUS.formatLong.date({ width: 'short' }), { locale: enUS })})`}
                            name="date-picker-acs"
                        />
                    </Col>
                }


            </Row>
            <Row className="store-product-details-row">
                <Col lg={4}>
                    <CheckboxSet>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    name="checkbox-subscription-select"
                                    label="3DS Server Setup (Pre-Production only)"
                                    value={props.THREE_DS_SERVER_SETUP}
                                    onChange={props.handleSubscriptionSelected}
                                />
                            </CheckboxListItem>
                        </CheckboxList>
                    </CheckboxSet>
                </Col>
                {props.selectedSubscription != null && props.selectedSubscription.values.includes(props.THREE_DS_SERVER_SETUP) &&
                    <Col lg="4">

                        <DateSelector
                            className="subscription-select-startdate"
                            label={`Start Date (example, ${format(new Date(), enUS.formatLong.date({ width: 'short' }), { locale: enUS })})`}
                            name="date-picker-3ds"
                        />
                    </Col>
                }
            </Row>

            <Divider type="section" />
        </>
    );
}

export default OtherProductDetails